/* SEW Markaz — cart cross-sell loader

   Dawn's own <product-recommendations> element is not bundled in this theme,
   so rather than depending on it we fetch the section ourselves. Same
   endpoint, same caching, one fewer thing that can silently be missing. */

(function () {
  function load() {
    var host = document.querySelector('[data-sew-cart-rec]');
    if (!host || host.dataset.sewLoaded === 'true') return;
    var url = host.getAttribute('data-url');
    if (!url) return;
    host.dataset.sewLoaded = 'true';

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('recommendations ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sew-cart-rec]');
        if (!fresh) return;
        var block = fresh.querySelector('.sew-cart-rec');
        if (!block) return; // nothing to recommend — leave the cart clean
        host.innerHTML = block.outerHTML;
      })
      .catch(function () {
        /* a missing cross-sell is not worth an error on the cart page */
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', load);
  } else {
    load();
  }
  document.addEventListener('shopify:section:load', load);
})();
